
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.678 12.477v1.92a5.759 5.759 0 00-5.759 5.758H0a7.678 7.678 0 017.678-7.678zm0-.96a5.757 5.757 0 01-5.759-5.759A5.757 5.757 0 017.678 0a5.757 5.757 0 015.758 5.758 5.757 5.757 0 01-5.758 5.759zm0-1.92a3.838 3.838 0 003.839-3.839A3.838 3.838 0 007.678 1.92a3.838 3.838 0 00-3.839 3.84 3.838 3.838 0 003.839 3.838zm5.758 10.078l-2.82 1.483.538-3.14-2.281-2.225 3.154-.46 1.41-2.856 1.41 2.857 3.153.459-2.281 2.224.537 3.14-2.82-1.482z","fill":"#667080"}})])
          )
        }
      }
    